var submissionForminit;

(function ($) {

	const selectors = {
		form: '[data-submission-form]',
		reason_select: '[data-reason-select]',
		reason_custom: '[data-reason-custom]'
	}

	submissionForminit = function () {
		$(selectors.form).each((i, el) => {
			new Form(el);
		});
	}

	class Form {
		constructor(element) {
			this.$form = $(element);

			this.init();
			this.bind();

			$(this.reason_select).trigger('change');

		}
		init() {
			this.$buttons = $('[type="submit"]', this.$form);

			this.required_fields = ['name', 'email', 'over16', 'rodo'];
			this.reason_select = $(selectors.reason_select, this.$form).get(0);

		}

		bind() {
			$(this.reason_select).change(() => { this.onReasonSelectChange(); });
			$('[type="submit"]', this.$form).on('click', () => { this.validate(); });
			this.$form.on('submit', (e) => { e.preventDefault(); this.submit(); });
		}

		validate() {
			var valid = true;

			var values = this.$form.serializeArray();
			var formatted_values = {};

			$.each(values, function (i, val) {
				formatted_values[val.name] = val.value;
			});

			$('.is-invalid', this.$form).removeClass('is-invalid');

			$.each(this.required_fields, function (i, field_name) {
				if (!formatted_values[field_name] || !formatted_values[field_name].length) {
					valid = false;
					$('[name="' + field_name + '"]', this.$form).addClass('is-invalid');
				}
			});

			return valid;

		}

		submit() {

			if (this.$buttons.hasClass('is-loading')) return;
			if (!this.validate()) return false;

			var self = this;

			$('[data-form-status]', this.$form).text('').hide().attr('class', 'c-petycja-box__form-status');

			this.$buttons.addClass('is-loading');

			var values = this.$form.serializeArray();
			var formatted_values = {};
			$.each(values, function (i, val) {
				formatted_values[val.name] = val.value;
			});


			$.ajax({
				type: "POST",
				url: 'submission.php',
				dataType: 'json', // data type
				data: formatted_values, // serializes the form's elements.
				success: function (response) {

					self.$buttons.removeClass('is-loading');

					if (response.status) {
						if (response.status == "success") {
							$('[data-form-status]', this.$form).addClass('status-' + response.status);
							self.clear();
							window.location.href = '/dziekujemy';
						}
					}

					// console.log(response); 
					if (response.message) {
						$('[data-form-status]', this.$form).text(response.message).show();
					}


				}
			});


		}

		clear() {
			$('[type="text"],[type="email"], textarea', self.$form).val('');
			$('[type="checkbox"]', self.$form).prop('checked', false);
			$('select option[value=""]').prop('selected', true).trigger('change');
		}

		onReasonSelectChange() {

			var $selected_option = $(this.reason_select[this.reason_select.selectedIndex]);

			if ($selected_option.attr('data-custom') !== undefined) {
				$(selectors.reason_custom, this.$form).stop().slideDown().find('textarea').focus();
			}
			else {
				$(selectors.reason_custom, this.$form).stop().slideUp().find('textarea').blur();
			}

		}

	}
})(jQuery);

export default submissionForminit;
